module.exports = __webpack_public_path__ + "static/twitter-14bf746d041314431ae2992a5648c13f.png";